<template>
  <div>
    <CustomAlert type="info" :withIcon="false">
      <div class="d-flex align-items-center template-alert">
        <p class="mb-0">
          Aby poprawnie przygotować plik z adresami pobierz szablon, wypełnij go wymaganymi danymi,
          a następnie wczytaj go w polu poniżej.
        </p>
        <a :href="templateUrl" class="btn btn-outline-tertiary" download>Pobierz szablon</a>
      </div>
    </CustomAlert>
    <ValidationProvider rules="required" v-slot="{ validate, errors }" tag="div" class="form-group">
      <div>
        <input
          type="file"
          id="file"
          ref="file"
          @change="handleDeliveryFileUpload($event) || validate($event)"
          style="display: none"
        />
        <a id="button" class="btn btn-outline-primary w-100" @click="handleFileButtonClick">
          {{ uploadBtnText }}
        </a>
        <div>
          <CustomAlert type="warning" :open.sync="isErrorAlertOpen" class="mt-5">
            <b>Uwaga!</b><br />{{ errorMsg }}
          </CustomAlert>
        </div>
        <img class="loader" src="/images/loader.gif" v-if="isUploading" />
        <ul class="errors">
          <li class="text-danger">{{ errors[0] }}</li>
        </ul>
      </div>
    </ValidationProvider>
    <div v-if="isLoaded">
      <CustomAlert type="success" :withIcon="false" class="mt-5">
        <p class="mb-0">
          Wczytano punkty dostaw: {{ parsedDeliveryPointsCount }}. Sprawdź poprawność danych w
          tabeli poniżej.
        </p>
      </CustomAlert>
      <delivery-points-table :deliveryPoints="parsedDeliveryPoints" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DeliveryFileRepository from '@/repositories/deliveryFileRepository';
import CustomAlert from '@/components/CustomAlert.vue';
import DeliveryPointsTable from '@/components/DeliveryPoints/DeliveryPointsTable.vue';
import { DataLayerManager } from '@/utils/DataLayerManager';

export default {
  name: 'DeliveryPointsFileForm',
  components: {
    CustomAlert,
    DeliveryPointsTable,
  },
  data() {
    return {
      uploading: false,
      isErrorAlertOpen: false,
      errorMsg: '',
      isLoaded: false,
      parsedDeliveryPointsCount: 0,
      parsedDeliveryPoints: [],
    };
  },
  computed: {
    ...mapState({
      hasIndividualPersonalization: state => state.confection.hasIndividualPersonalization,
    }),
    uploadBtnText() {
      return 'Prześlij plik';
    },
    isUploading() {
      return this.uploading;
    },
    hasPersonalizedConfection() {
      return this.$store.getters['delivery/hasPersonalizedConfectionInCart'];
    },
    shouldAttachFileWithConfection() {
      return !!(this.hasPersonalizedConfection && this.hasIndividualPersonalization);
    },
    templateUrl() {
      if (this.shouldAttachFileWithConfection) {
        return '/docs/formularze_zamowien/dane_dostaw_z_konfekcją.xlsx';
      }
      return '/docs/formularze_zamowien/dane_dostaw.xlsx';
    },
  },
  methods: {
    handleFileButtonClick() {
      this.$refs.file.value = null;
      this.$refs.file.click();
    },
    handleDeliveryFileUpload() {
      const file = this.$refs.file.files[0];
      if (!file || file === '') return;

      this.submitFile(file);
    },
    async submitFile(file) {
      this.uploading = true;
      this.isLoaded = false;
      DeliveryFileRepository.checkDeliveryFile(file, this.shouldAttachFileWithConfection)
        .then(async ({ data }) => {
          if (data.error) {
            this.errorMsg = data.error.message;
            this.isErrorAlertOpen = true;
          } else {
            this.errorMsg = '';
            this.isErrorAlertOpen = false;
            this.isLoaded = true;
            this.parsedDeliveryPoints = data;
            this.parsedDeliveryPointsCount = data.length;
            const cartItems = await this.$store.dispatch(
              'delivery/hydrateValidatedDeliveryFile',
              data,
            );
            cartItems.forEach((cartItem) => {
              if (!cartItem.analyticsData) return;
              DataLayerManager.pushAddToCartEvent(cartItem);
            });
          }
        })
        .catch((error) => {
          this.errorMsg = error.message;
          this.isErrorAlertOpen = true;
        })
        .finally(() => {
          this.uploading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.template-alert {
  gap: 1.6rem;
  flex-direction: column;

  @media (min-width: 576px) {
    flex-direction: row;
  }
}
</style>
